export default __webpack_public_path__ + "static/media/09.23557d16.jpg";